'use client';
import { Button, ButtonProps } from '@mui/material';
import * as React from 'react';
import { CalendlyProps } from '../lib/types';
import { ScheduleACallClickable } from './schedule-a-call-clickable';

interface Props extends ButtonProps {
  calendlyProps?: CalendlyProps & { width?: number | string, subtitle?: string };
  onClose?: () => void;
}

export const ScheduleACallButton = (props: Props) => {
  const { calendlyProps, onClose, children, ...rest } = props;

  return (
    <ScheduleACallClickable
      {...props}
      Component={Button}
      componentProps={{
        variant: 'contained',
        color: 'primary',
        children: children || 'Schedule a call',
        ...rest
      }}
      onClose={onClose}
      calendlyProps={calendlyProps}
    />
  );
};
